import React from 'react'
import { Skeleton, Box } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import { useToast } from '@hooks'
import { isLoadingCommonFilters } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import { countryColumn, retailerColumn, hasDataColumn, keywordColumn, scoreColumn, productsFoundColumn } from './columns'
import { useShareOfSearchStatusFilters } from "../@hooks";


export default function ShareOfSearchStatusTable() {

    const { data } = useShareOfSearchStatusFilters()
    const { showToast } = useToast()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns = [
        ...countryColumn(),
        ...retailerColumn(),
        keywordColumn(),
        ...hasDataColumn(),
        productsFoundColumn(),
        scoreColumn()
    ]

    return <AppTableSeeker
        data={data}
        title={<TitleWithPopover title={'Keyword Status'} />}
        columns={columns}
        options={{
            tableBodyHeight: '700',
            onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/share-of-search/keyword-status/excel`),
            viewColumns: false,
        }}
    />

}